import { HomeDisplayCategory } from 'src/admin-entity/interface/home-display/home-display-category.interface';
import { HomeDisplayItem } from 'src/admin-entity/interface/home-display/home-display-item.interface';
import { HomeDisplayTab } from 'src/admin-entity/interface/home-display/home-display-tab.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';
export interface HomeDisplayInitialState {
    selectedHomeDisplayCategoryItems: Page<HomeDisplayItem>;
    selectedHomeDisplayCategoryTabList: Page<HomeDisplayTab>;
    originProducts: Page<HomeDisplayItem>;
    homeDisplayCategoryList: HomeDisplayCategory[];
    selectedParentHomeDisplayCategory: HomeDisplayCategory;
    selectedHomeDisplayCategory: HomeDisplayCategory;
    homeDisplayCategoryForAdd: HomeDisplayCategory;
}

const temp: HomeDisplayCategory = {
    id: 0,
    name: 'test',
    title: 'test',
    status: false,
    orderByType: 'manual',
    displayUiType: 1,
    bannerRollingType: 1,
    displayContentsType: 'product',
    showInformation: false,
    products: [],
    category: { id: 0 },
    createDate: '2023-02-23' as any,
    excludeCommingSoon: false,
    displayCategoryImages: [],
    tabType: 'buttonType',
    showSoldOut: false,
};

export const initialState: HomeDisplayInitialState = {
    selectedHomeDisplayCategoryItems: {
        list: [],
        page: {
            count: 0,
            nextPage: null,
        },
    },
    selectedHomeDisplayCategoryTabList: {
        list: [],
        page: {
            count: 0,
            nextPage: null,
        },
    },
    originProducts: {
        list: [],
        page: {
            count: 0,
            nextPage: null,
        },
    },
    homeDisplayCategoryList: [],
    selectedParentHomeDisplayCategory: temp,
    selectedHomeDisplayCategory: temp,
    homeDisplayCategoryForAdd: temp,
};
